import { NgModule } from '@angular/core';
import {
  FaConfig,
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

@NgModule({
  imports: [FontAwesomeModule],
  exports: [FontAwesomeModule],
})
export class FaIconModule {
  constructor(
    private readonly library: FaIconLibrary,
    private readonly faConfig: FaConfig,
  ) {
    library.addIcons(faBars);
    faConfig.fixedWidth = true;
  }
}
